import { getOcelotConfig } from 'lib/configs/ocelot';
import React from 'react';

const alWebShouldFallback = getOcelotConfig('mobileApp.meta.al:web:should_fallback') || 'true';
const alAndroidUrl = getOcelotConfig('mobileApp.meta.al:android:url');
const alAndroidAppName = getOcelotConfig('mobileApp.meta.al:android:app_name');
const alAndroidPackage = getOcelotConfig('mobileApp.meta.al:android:package');
const alIosUrl = getOcelotConfig('mobileApp.meta.al:ios:url');
const alIosAppStoreId = getOcelotConfig('mobileApp.meta.al:ios:app_store_id');
const alIosAppName = getOcelotConfig('mobileApp.meta.al:ios:app_name');

const appFacebookDeepLinkingConfigAvailable =
  !!alWebShouldFallback &&
  !!alAndroidUrl &&
  !!alAndroidAppName &&
  !!alAndroidPackage &&
  !!alIosUrl &&
  !!alIosAppStoreId &&
  !!alIosAppName;

// Documentation 👉 https://developers.facebook.com/docs/applinks/metadata-reference/
const appFacebookDeepLinkingMetaData = appFacebookDeepLinkingConfigAvailable ? (
  <React.Fragment key="appFacebookDeepLinks">
    <meta property="al:web:should_fallback" content={alWebShouldFallback} />
    <meta property="al:android:url" content={alAndroidUrl} />
    <meta property="al:android:app_name" content={alAndroidAppName} />
    <meta property="al:android:package" content={alAndroidPackage} />
    <meta property="al:ios:url" content={alIosUrl} />
    <meta property="al:ios:app_store_id" content={alIosAppStoreId} />
    <meta property="al:ios:app_name" content={alIosAppName} />
  </React.Fragment>
) : undefined;

export const appPageMeta = [appFacebookDeepLinkingMetaData];
